export const getCurrentTotal = ({ splits }) => {
    console.log('splits', splits)
    const total = splits.reduce((sum, { amount }) => sum + (amount || 0), 0)
    return Math.round((total || 0) * 100) / 100
}